export default __webpack_public_path__ + "static/logo-46f3d9ed9543cc4fbd2b19a06ba7d450.svg";